import { Link } from "react-router";

export function NotFoundPage() {
  return (
    <div className="bg-bg flex min-h-screen flex-col items-center justify-center px-4">
      <h1 className="font-display text-fg text-6xl font-bold">404</h1>
      <p className="text-fg-muted mt-4 text-lg">Page not found</p>
      <Link to="/queue" className="text-fg mt-6 text-sm underline">
        Back to the offboarding queue
      </Link>
    </div>
  );
}
